import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "show-wrap" }
const _hoisted_3 = { class: "show-box one" }
const _hoisted_4 = { class: "center" }
const _hoisted_5 = { class: "text-wrap" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"text-box\"><div class=\"title\"><div>多平台多店铺安全运营管理专家</div></div><div class=\"text-list\"><div class=\"text-item\">跨境电商多平台多账号</div><div class=\"text-item\">安全运营提速解决方案</div></div></div>", 1)
const _hoisted_7 = { class: "btn-item" }
const _hoisted_8 = { class: "image" }
const _hoisted_9 = { class: "show-box two" }
const _hoisted_10 = { class: "center" }
const _hoisted_11 = { class: "text-wrap" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"text-box\"><div class=\"title\"><div>店铺安全是我们的核心关注</div></div><div class=\"text-list\"><div class=\"text-item\">独享固定环境+固定IP</div><div class=\"text-item\">隔离本地电脑环境</div><div class=\"text-item\">店铺账号数据多重加密处理</div><div class=\"text-item\">隔离本地电脑环境</div><div class=\"text-item\"></div><div class=\"text-item\"> 让你在任意电脑任意网络下异地办公也能安全管理账号 </div></div></div>", 1)
const _hoisted_13 = { class: "btn-item" }
const _hoisted_14 = { class: "image" }
const _hoisted_15 = { class: "image-wrap" }
const _hoisted_16 = { class: "name" }
const _hoisted_17 = { class: "show-box three" }
const _hoisted_18 = { class: "center" }
const _hoisted_19 = { class: "text-wrap" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"text-box\"><div class=\"title\"><div>支持跨平台团队多人协作</div></div><div class=\"text-list\"><div class=\"text-item\">免费子账号系统，访问权限自由分配</div><div class=\"text-item\">多人管理1店铺，多人管理多店铺</div><div class=\"text-item\"> 多人多地同时操作访问，操作日志记录，问题可追溯 </div><div class=\"text-item\"></div><div class=\"text-item\"> 不限时间，地点，任意电脑任意网络下打开闪店就能 </div><div class=\"text-item\"> 实现异地办公，安全便捷有效管理店铺账号 </div></div></div>", 1)
const _hoisted_21 = { class: "btn-item" }
const _hoisted_22 = { class: "image" }
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"show-box four\"><div class=\"center\"><div class=\"text-wrap\"><div class=\"text-box\"><div class=\"title\"><div>一款让店铺管理更安全</div><div>更高效的企业软件</div></div><div class=\"text-list\"><div class=\"text-item\"> 闪店VPS，为跨境电商特别开发的企业级安全浏览器。致力于解决亚马逊、eBay、Wish等电商平台 </div><div class=\"text-item\"> &quot;店铺关联问题。为跨境电商卖家提供专业安全的多店铺管理解决方案。多年跨境电商领域软件开发经验。 </div><div class=\"text-item\"> 已通过众多跨境电商团队多年实际应用检测安全———闪店VPS，一款让店铺管理更安全、更高效的企业软件。 </div></div></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", {
                class: "register-btn",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.gotoRegister && _ctx.gotoRegister(...args)))
              }, "免费注册下载")
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("img", {
              src: _ctx.images.one,
              alt: ""
            }, null, 8, ["src"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("div", _hoisted_13, [
              _createVNode("div", {
                class: "register-btn",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoRegister && _ctx.gotoRegister(...args)))
              }, "免费注册下载")
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images.indexIcons, (iconItem) => {
                return (_openBlock(), _createBlock("div", {
                  class: "image-item",
                  key: iconItem.uid
                }, [
                  _createVNode("img", {
                    src: iconItem.src,
                    alt: ""
                  }, null, 8, ["src"]),
                  _createVNode("div", _hoisted_16, _toDisplayString(iconItem.title), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_17, [
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode("div", _hoisted_21, [
              _createVNode("div", {
                class: "register-btn",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.gotoRegister && _ctx.gotoRegister(...args)))
              }, "免费注册下载")
            ])
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode("img", {
              src: _ctx.images.three,
              alt: ""
            }, null, 8, ["src"])
          ])
        ])
      ]),
      _hoisted_23
    ])
  ]))
}